import styled from 'styled-components';

export const PlaybackTime = styled.span`
  ${({ theme }) => theme.typography.variants.mono.default};
`;
